import styled from 'styled-components';

const AddDriverWrapper = styled.div`
.insured-wrapper {
  padding: 1rem 0;
  h2 {
    font-size: 24px;
    font-weight: bold;
    color: #4c565c;
    margin: 1rem 0;
  }
  .add_wrapper {
    background-color: #eef2f5;
  }
  .form-wrapper {
    // width: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-start;
    // align-items: flex-start;
    padding: 3rem 1rem 1rem;
    .btn{
      border: 1px solid #6B47F5;
    }
  }

  .btn {
    font-size: 1rem;
    height: 40px;
    justify-content: center;
    width: 100%;
    text-transform: uppercase;
    &.primary {
      color: #fff;
      background: #6B47F5;
    }
    &.secondary {
      color: #fff;
      background: #6B47F5;
    }
    &.secondary-outline {
      color: #6B47F5;
      background: transparent;
      border-color: #6B47F5;
    }
    .pi{
      margin:0 5px;
    }
  }


  .drivers-list {
    padding: 0 1rem 1rem;
    display: flex;
    flex-direction: column;
    .review {
      display: block;
      color: #4c565c;
      font-weight: bold;
      text-align: initial;
    }
    .item {
      display: flex;
      border: solid 1px #edf2f5;
      background-color: #fff;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;
      margin: 1rem 0 0;
      .details {
        display: inline-flex;
        text-align: initial;
        img {
          height: 48px;
          margin-right: 10px;
        }
      }
      .divider {
        height: 30px;
        border-right: 1px solid #edf2f5;
      }
      .iqama {
        text-align: initial;
      }
      .name {
        text-align: initial;
        // color: #4c565c !important;
      }
      .license {
        font-size: 13px;
        font-weight: bold;
        color: #6B47F5;
        margin-bottom: 0;
        text-align: initial;
      }
      .header-title {
        height: 13px;
        // font-family: 'Bliss2', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 13px;
        color: #818b9b;
        margin-bottom: 5px;
        text-align: initial;
      }
      .usage {
        .header-title {
          margin-bottom: 5px;
        }
      }
      .usage-list {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        &.gender-list{
          .item{
            width:75px !important;
          }
        }
        .item {
          cursor: pointer;
          text-transform: uppercase;
          font-size: 13px;
          font-weight: normal;
          font-family: "OpenSans";
          height: 28px;
          flex-grow: 0;
          display: inline-flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 5px;
          border-radius: 0;
          border: solid 1px #6B47F5;
          margin: 0 5px 0 0;
          span {
            font-size: 13px;
            color: #6B47F5;
          }
          &.active {
            background-color: #6B47F5;
            border-color: #6B47F5;
            span {
              color: #fff;
            }
            path {
              fill: #fff;
            }
          }
          .svg_wrapper {
            margin-right: 5px;
          }
          svg {
            height: 16px;
            path {
              fill: #6B47F5;
            }
          }
        }
      }

      .actions {
        min-width: 20%;
        display: inline-flex;
        justify-content: flex-end;
        .m {
          display: none;
        }
      }
      .btns {
        display: inline-flex;
        .btn {
          display: inline-flex;
          
          align-items: center;
          justify-content: flex-end;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          padding: 0;
          &:first-of-type {
            margin-right: 12px;
          }
          img {
            height: 24px;
          }
        }
        .danger {
          background: #ef2f2f;
          padding: 0;
          margin: 0 5px 0 0;
        }
        .primary {
          padding: 0;
          margin: 0;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .add_wrapper {
      border-radius: 10px;
    }
    .drivers-list {
      .divider {
        display: none;
      }
      .item {
        flex-direction: column;
        .details,
        .iqama,
        .year-birth,
        .usage {
          width: 100%;
          display: inline-flex;
          justify-content: space-between;
          padding-bottom: 10px;
          padding-top: 10px;
          border-bottom: 1px solid #edf2f5;
          .header-title {
            margin: 0;
          }
        }

        .actions {
          width: 100%;
          flex-direction: column;
          .btns {
            // display: none;
          }
          .m {
            display: block;
          }
        }
        .usage {
          border-bottom: 0;
          .header-title {
            padding-top: 5px;
          }
        }
        .btns {
          height: 24px;
          img {
            height: 24px;
          }
          margin-right: 0;
          margin-left: auto;
        }
      }
    }
  }

  &.ar {
    .btns {
      .btn {
        &:first-of-type {
          margin-right: 0 !important;
          margin-left: 12px !important;
        }
      }
    }
    .drivers-list .usage-list .item{
      margin-right: 0;
      margin-left: 5px;
    }
    .drivers-list .item .usage-list .item .svg_wrapper{
      margin-right: 0;
      margin-left: 5px;
    }
  }
}
`;
export default AddDriverWrapper;